import { onlineManager } from "@tanstack/react-query";
import type { EncryptionKeyManager } from "./EncryptionKeyManager";
import type { KeyValueStorage } from "./KeyValueStorage";

export class BrowserEncryptionKeyManager implements EncryptionKeyManager {
	static readonly ENCRYPTION_KEY_UUID_STORAGE_KEY = "encryption-key-uuid";

	private key: string | null = null;
	private ongoingKeyFetch: Promise<string> | null = null;

	constructor(
		private readonly preferenceStorage: KeyValueStorage,
		private readonly serverApi: {
			createServerKey: () => Promise<{
				keyUuid: string;
				decryptedKey: string;
			}>;
			getServerKey: (id: string) => Promise<string | null>;
		},
	) {}
	async getKey(): Promise<string> {
		if (this.ongoingKeyFetch) {
			return this.ongoingKeyFetch;
		}

		if (this.key) {
			return this.key;
		}

		const fetchKey = async () => {
			const keyUuid = await this.preferenceStorage.getItem(
				BrowserEncryptionKeyManager.ENCRYPTION_KEY_UUID_STORAGE_KEY,
			);
			const key = keyUuid ? await this.serverApi.getServerKey(keyUuid) : null;
			if (!key) {
				const newKey = await this.serverApi.createServerKey();
				await this.preferenceStorage.setItem(
					BrowserEncryptionKeyManager.ENCRYPTION_KEY_UUID_STORAGE_KEY,
					newKey.keyUuid,
				);
				this.key = newKey.decryptedKey;
			} else {
				this.key = key;
			}
			return this.key;
		};

		this.ongoingKeyFetch = fetchKey();
		return this.ongoingKeyFetch.finally(() => {
			this.ongoingKeyFetch = null;
		});
	}

	isAvailable(): boolean {
		return (
			this.preferenceStorage.isAvailable() &&
			(onlineManager.isOnline() || !!this.key)
		);
	}
}
